export default __webpack_public_path__ + "static/media/image.e4308c00.svg";